import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';

export const templateChangePartnerMenu = document.createElement('template');

templateChangePartnerMenu.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='change-partner-wrapper'>
    <div id='change-partner-inner-container'>
      <gz-title fontSize='14' fontWeight='500' class='company-name' id='change-partner-company-name'></gz-title>
      <gz-title fontSize='24' fontWeight='500' id='change-partner-title'></gz-title>

      <p id='change-partner-info-text'></p>
      <gz-info-box id='change-partner-ec2-notice-container' severity="warning"></gz-info-box>


      <gz-title fontSize='11' fontWeight='600' id='change-partner-form-title'></gz-title>

      <p id='change-partner-company-id-label'></p>

      <gz-form-field id='change-partner-company-id'>
        <gz-input gz-form-input placeholder=''></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <div class='message-box box-error hidden' id='change-partner-backend-error-container'>
        <span class='ds-icon ds-icon-notification_negative danger mr-2'></span>
        <span id='change-partner-backend-error-text'></span>
      </div>
    </div>

    <div style='flex: auto;'></div>

    <div class='bottom-buttons'>
        <gz-button id='change-partner-submit-button' disabled></gz-button>
        <gz-button type='outline' color='secondary' id='change-partner-cancel-button'></gz-button>
    </div>
  </div>
`;
